import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { addNotification } from 'loot-core/client/actions';
import { send } from 'loot-core/platform/client/fetch';

import { useNavigate } from '../../../hooks/useNavigate';
import { theme } from '../../../style';
import { ButtonWithLoading } from '../../common/Button';
import { Input } from '../../common/Input';
import { Text } from '../../common/Text';
import { View } from '../../common/View';
import { FormField, FormLabel } from '../../forms';

export function ChangePasswordForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    setErrorMsg('');
    e.preventDefault();
    if (loading) {
      return;
    }

    if (password1.length < 8) {
      setErrorMsg('Your password must be at least 8 characters long');
      return;
    }

    if (password1 === password2) {
      setLoading(true);
      const { error } = await send('subscribe-change-password', {
        currentPassword,
        newPassword: password1,
      });

      if (error) {
        console.error(error);
        if (error === 'invalid-password') {
          setErrorMsg('Your current password is wrong.');
        } else {
          setErrorMsg('Something wrong has happened.');
        }
      } else {
        dispatch(
          addNotification({
            type: 'message',
            message: 'Your password has been successfully changed.',
          }),
        );
        navigate('/');
      }
      setLoading(false);
    } else {
      setErrorMsg('The confirm password does not match.');
    }
  }

  return (
    <form
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 8,
      }}
      onSubmit={onSubmit}
    >
      <FormField style={{ flex: 1 }}>
        <View style={{ flexDirection: 'row' }}>
          <FormLabel title="Current password" htmlFor="currentPassword" />
          &nbsp;<Text style={{ color: theme.errorText }}> * </Text>
        </View>
        <Input
          type="password"
          name="currentPassword"
          value={currentPassword}
          required={true}
          onChange={e => {
            setCurrentPassword(e.target.value);
          }}
        />
      </FormField>
      <FormField style={{ flex: 1 }}>
        <View style={{ flexDirection: 'row' }}>
          <FormLabel title="New password" htmlFor="password1" />
          &nbsp;<Text style={{ color: theme.errorText }}> * </Text>
        </View>
        <Input
          value={password1}
          type="password"
          name="password1"
          required={true}
          onChange={e => {
            setPassword1(e.target.value.trim());
          }}
        />
      </FormField>
      <FormField style={{ flex: 1 }}>
        <View style={{ flexDirection: 'row' }}>
          <FormLabel title="Confirm new password" htmlFor="password2" />
          &nbsp;<Text style={{ color: theme.errorText }}> * </Text>
        </View>
        <Input
          value={password2}
          type="password"
          name="password2"
          required={true}
          onChange={e => {
            setPassword2(e.target.value.trim());
          }}
        />
      </FormField>

      {errorMsg && <View style={{ color: theme.errorText }}>{errorMsg}</View>}

      <ButtonWithLoading disabled={loading} type="primary">
        Confirm password change
      </ButtonWithLoading>
    </form>
  );
}
